import type { Permission } from '@icetus/contracts';

/**
 * 角色权限表的内容：一行一种「能干的事」，四列是四种角色。
 *
 * 权限点是按"能造成什么后果"切的（见 `contracts/permissions.ts`），那种切法
 * 适合服务端判定，但不适合拿给人看 —— 客户不会问"我能不能 `content:publish`"，
 * 他问的是"这人能不能把页面发出去"。所以这里把权限点翻成人话，
 * **一一对应到 `ROLE_PERMISSIONS`，不在本地重抄矩阵**：之后谁动了权限点，
 * 这张表跟着变，不会变成一句谎话。
 *
 * 空数组 = 不需要任何权限点，也就是四种角色都有（"看一眼"本来就不需要授权）。
 *
 * 覆盖性由 `role-caps.test.ts` 盯着：新增权限点却忘了在这里加一行，
 * 门禁会红，而不是让客户看到一张过期的表。
 */
export const CAPABILITIES: { label: string; permissions: readonly Permission[] }[] = [
  { label: '查看页面内容', permissions: [] },
  { label: '改页面、商品与图片', permissions: ['content:write', 'media:write'] },
  { label: '查看买家询盘', permissions: ['lead:read'] },
  { label: '发布 / 下线页面', permissions: ['content:publish'] },
  { label: '发起 AI 翻译', permissions: ['translation:run'] },
  {
    label: '改站点信息、绑域名、新建站点',
    permissions: ['site:update', 'domain:manage', 'site:create'],
  },
  { label: '查看操作记录', permissions: ['audit:read'] },
  { label: '邀请成员、改角色', permissions: ['member:manage'] },
  { label: '下单、升降套餐', permissions: ['billing:manage'] },
];
